import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { NaacHeadingRoutingModule } from './naac-heading-routing.module';
import { NaacHeadingListComponent } from './naac-heading-list/naac-heading-list.component';
import { NaacHeadingCreateComponent } from './naac-heading-create/naac-heading-create.component';

@NgModule({
  declarations: [NaacHeadingListComponent, NaacHeadingCreateComponent],
  imports: [
    CommonModule,
    NaacHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class NaacHeadingModule { }
